import { OnInit } from '@angular/core';
import { LoginService } from '../services/login.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Globals } from '../objects/Globals';
import { TokenManager } from '../Globals';
var ContinuesessionComponent = /** @class */ (function () {
    function ContinuesessionComponent(loginService, route, globals, router, tokenManager) {
        this.loginService = loginService;
        this.route = route;
        this.globals = globals;
        this.router = router;
        this.tokenManager = tokenManager;
    }
    ContinuesessionComponent.prototype.ngOnInit = function () {
    };
    ContinuesessionComponent.prototype.Login = function (username, password) {
        var _this = this;
        var sessionId = this.route.snapshot.paramMap.get("sessionKey");
        this.loginService.continueSession(username, password, sessionId).subscribe(function (result) {
            _this.globals.Session = result;
            _this.globals.CardItems = [];
            _this.router.navigate(['/', 'home']);
            _this.loginService.setSession(result);
            if (_this.globals.Session.Session.SessionId != null) {
                _this.tokenManager.store('BRNSessionKey', _this.globals.Session.Session.SessionId);
            }
        });
    };
    return ContinuesessionComponent;
}());
export { ContinuesessionComponent };
